import { ReportTypeEnum } from '../type';

/* eslint no-shadow: "off" */
export enum VERIFY_STATUS_ENUM {
  ALL = -1,
  WAIT_SUBMIT = 0,
  WAIT_AUDIT = 1,
  PASS = 2,
  REJECT = 3,
}
export enum GIVE_STATUS_ENUM {
  ALL = -1,
  WAIT = 0,
  SUCCESS = 1,
  FAIL = 2,
}

export type VERIFY_STATUS =
  | VERIFY_STATUS_ENUM.WAIT_SUBMIT
  | VERIFY_STATUS_ENUM.WAIT_AUDIT
  | VERIFY_STATUS_ENUM.PASS
  | VERIFY_STATUS_ENUM.REJECT;

export type GIVE_STATUS = GIVE_STATUS_ENUM.SUCCESS | GIVE_STATUS_ENUM.FAIL | GIVE_STATUS_ENUM.WAIT;

export interface TableColumnsProps {
  /** 结算单号 */
  settlement_sn: number;
  /** 结算批次号 */
  settlement_batch: number;
  start_time: string;
  end_time: string;
  /** 总人数 */
  total_num: number;
  total_amount: number;
  /** 审核状态 */
  verify_status: VERIFY_STATUS;
  /** 发放状态 */
  give_status: GIVE_STATUS;
}

export enum ADJUST_TYPE {
  REWARD = 1,
  PUNISH = 0,
}

export enum ADJUST_TYPE_TEXT {
  '调增' = ADJUST_TYPE.REWARD,
  '调减' = ADJUST_TYPE.PUNISH,
}

export enum ADJUST_METHOD {
  DURATION = 1,
  REWARD_PUNISH = 2,
}

export enum EXPORT_STATUS {
  /** 导出 */
  YES = 1,
  /** 不导出 */
  NO = 0,
}

export enum IS_TEMPORARY {
  /** 是临时员工 */
  YES = 1,
  /** 不是临时员工 */
  NO = 0,
}

export enum SETTLE_STATUS_VALUE {
  '待提交' = VERIFY_STATUS_ENUM.WAIT_SUBMIT,
  '待审核' = VERIFY_STATUS_ENUM.WAIT_AUDIT,
  '审核通过' = VERIFY_STATUS_ENUM.PASS,
  '审核驳回' = VERIFY_STATUS_ENUM.REJECT,
}

export enum GIVE_STATUS_VALUE {
  '成功' = GIVE_STATUS_ENUM.SUCCESS,
  '失败' = GIVE_STATUS_ENUM.FAIL,
  '待发放' = GIVE_STATUS_ENUM.WAIT,
}

export interface ADJUST_SALARY {
  settlement_sn: number;
  settlement_order_sn: number;
  type: ADJUST_TYPE.REWARD | ADJUST_TYPE.PUNISH;
  amount: number;
  reason?: string;
}

export enum EWorkType {
  Delivery,
  IndividualDining,
}

export const WorkTypeList = [
  {
    label: '配送',
    value: EWorkType.Delivery,
  },
  {
    label: '分餐',
    value: EWorkType.IndividualDining,
  },
];

export const WorkTypeMap = ['配送', '分餐'];

export interface SettleReportProps {
  reportType: ReportTypeEnum;
  [key: string | number | symbol]: any;
}
